export default "__VITE_ASSET__Bvjz15aV__"